export default __webpack_public_path__ + "static/media/cwd.3a14880e.svg";